import Axios from "axios";
import { apiHost } from "../constants/ApiConstants";
// import JwtUtils from "../utils/jwtUtils";
import apiClient from "./ApiClient";

export default class ApiPayments {
  // static async activateAccount(sessionId) {
  //   return await apiClient
  //     .post(`${apiHost}/payments/activateAccount`, {
  //       sessionId: sessionId,
  //     })
  //     .then((response) => {
  //       let responseLog = { status: response.status, data: response.data };

  //       return responseLog;
  //     })
  //     .catch((error) => {
  //       let errorLog = {
  //         status: error.response?.status,
  //         data: error.response?.data,
  //       };

  //       return errorLog;
  //     });
  // }

  static async createCheckoutSession(stripePricesKey, userLanguage) {
    return await apiClient
      .get(
        `${apiHost}/payments/createCheckoutSession/${stripePricesKey}/${userLanguage}`
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = {
          status: error.response?.status,
          data: error.response?.data,
        };

        return errorLog;
      });
  }

  static async getSessionStatus(sessionId) {
    return await apiClient
      .get(`${apiHost}/payments/sessionStatus/${sessionId}`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = {
          status: error.response?.status,
          data: error.response?.data,
        };

        return errorLog;
      });
  }

  static async cancelSubscription() {
    return await apiClient
      .get(`${apiHost}/payments/cancelSubscription/`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = {
          status: error.response?.status,
          data: error.response?.data,
        };

        return errorLog;
      });
  }

  static async getCustomerPortalSession() {
    return await apiClient
      .get(`${apiHost}/payments/stripeCustomerPortal/`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = {
          status: error.response?.status,
          data: error.response?.data,
        };

        return errorLog;
      });
  }

  static async getPackInfos() {
    return await apiClient
      .get(`${apiHost}/payments/packsInfos`, {})
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = {
          status: error.response?.status,
          data: error.response?.data,
        };

        return errorLog;
      });
  }

  static async createStripeConnectAccount() {
    return await apiClient
      .post(`${apiHost}/payments/stripeConnectSignup`, {}, {})
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }
  // Route publique (aucune auth) appelée depuis la page de retour Stripe.
  // Le sessionId est un secret de session : il ne doit jamais être journalisé
  // ni laissé dans l'URL après lecture.
  static async getPaymentSuccessInfo(paymentLinkId, sessionId) {
    return await apiClient
      .get(
        `${apiHost}/payments/paymentSuccessInfo/${encodeURIComponent(
          paymentLinkId
        )}/${encodeURIComponent(sessionId)}`
      )
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  // Factures mensuelles de commission. Attention : totalHT / totalVat /
  // totalTTC sont exprimés en centimes.
  static async getCommissionInvoices() {
    return await apiClient
      .get(`${apiHost}/payments/commissionInvoices`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  // Variante admin : factures d'un vendeur donné, consultées depuis sa fiche
  // client. Le téléchargement passe par la même route que côté vendeur.
  static async getSellerCommissionInvoices(sellerId) {
    return await apiClient
      .get(`${apiHost}/payments/commissionInvoices/seller/${sellerId}`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  // L'URL renvoyée est signée et n'est valable que 5 minutes : elle doit être
  // consommée immédiatement, jamais mise en cache.
  static async getCommissionInvoiceDownloadUrl(invoiceId) {
    return await apiClient
      .get(`${apiHost}/payments/commissionInvoices/${invoiceId}/download`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }

  static async getStripeConnectAccount() {
    return await apiClient
      .get(`${apiHost}/payments/stripeConnectAccount`)
      .then((response) => {
        let responseLog = { status: response.status, data: response.data };

        return responseLog;
      })
      .catch((error) => {
        let errorLog = { status: 500, data: "Undefined error" };
        if (error.response) {
          errorLog = {
            status: error.response?.status,
            data: error.response?.data,
          };
        }

        return errorLog;
      });
  }
}
